import * as React from "react";
import { TextField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /articles/{articleId}/comments — suppression : DELETE /articles/comments/{id}
export default {
  list: subResourceList({
    parentParam: "articleId",
    parentLabel: "ID article",
    canDelete: true,
    children: [
      <TextField key="content" source="content" label="Commentaire" />,
      <TextField key="author" source="authorDisplayName" label="Auteur" />,
      <TextField key="authorId" source="authorId" label="ID auteur" />,
      <FrDateField key="createdAt" source="createdAt" label="Date" showTime />,
    ],
  }),
};
